import React, { useMemo } from "react";
import { useUsuario, UsuarioIncompleto } from "../../Hooks/UsuarioHook";
import { SeletorContasModal } from "../SeletorContasModal";

interface CustomPanelProps {
  open: boolean;
  onClose: () => void;
  senhaHelper: string;
  manterAutenticado?: boolean;
}

export const SelecionarContaLogin: React.FC<CustomPanelProps> = ({
  open,
  onClose,
  senhaHelper,
  manterAutenticado,
}) => {
  const { contasMesmoUsuario, logar } = useUsuario();

  const primeiroNome = useMemo(() => {
    const nome = contasMesmoUsuario?.[0]?.nome ?? "";
    return nome.split(" ")[0];
  }, [contasMesmoUsuario]);

  const handleItemClick = (conta: UsuarioIncompleto) => {
    logar(String(conta.id), senhaHelper, "id", manterAutenticado);
    onClose();
  };

  return (
    <SeletorContasModal
      open={open}
      onClose={onClose}
      titulo={`Olá${primeiroNome ? `, ${primeiroNome}` : ""}! 👋`}
      subtitulo="Em qual de suas contas você deseja entrar?"
      contas={contasMesmoUsuario}
      onSelecionar={handleItemClick}
    />
  );
};
